export default __webpack_public_path__ + "static/media/ambassador_nikol_ungvari.81357c80.jpg";